// Generated from analyticsDomains.json; run analytics generate:site-runtime.
import type { BrowserAnalyticsConfig } from "./domainConfig.gen";
export const siteAnalyticsConfigs: readonly BrowserAnalyticsConfig[] = [
  {
    "schemaVersion": 1,
    "hostname": "www.thenigerianblogger.com",
    "path": "/ExnB8CBaQNx3m8h8",
    "publicKey": {
      "kty": "RSA",
      "alg": "RSA-OAEP-256",
      "n": "oNpnj37NDlGGcx_B9hpIYFguNQ8GAnVu-yM3h8bPCE6uWbOKLXCiVS4zwEw2q5N5hXSV8R7xfdWhJcs2qQJ75EdfYqWT2mPD6WH-5_btkIsYdVaLVPsTuXoi8JWxCohOIwO_TyE_SDwPkY28NlyXgrzsqjJ3tuQupNoRYcykUHFiLmakJyYcPiX1bP4jWPX1GLgh09FCHkvhDSlEiVbFkmJdhatK5bjw6YyN9LraGGWNglDkItpCgNu8GtLkpfSJaIt-ZVl62JtRB_27I9bUq9c9nAKeRxa3Zjyr2A8lykcVw4uGEfRhfp3TlH7uTLtrf2vbcn3AWmsqpkEZATm2-Q",
      "e": "AQAB",
      "ext": true,
      "key_ops": [
        "encrypt"
      ]
    }
  },
  {
    "schemaVersion": 1,
    "hostname": "dev.thenigerianblogger.com",
    "path": "/5xnUyuRj9fZhrLdT",
    "publicKey": {
      "kty": "RSA",
      "alg": "RSA-OAEP-256",
      "n": "qKACs9g7vwBVouEvYrVdTFZQSroTFQa0hiPD-OfylX_x3lFGiNWqY2GwSGilKWRRHyGs7jzpFHvnMT468HWPNPtDBHLdQTKRmFo6JFLsuB-kUL9MXwOffDMz6oV54lPKbawmP1g7Zyuit1AHpbA2mJSGh_yeczvN2zD8mtGh128KOlAr_K17D2uspa3e2Y7a8lCrpnyd2pCjbo7RUnnHmUS9y0n1HOZuLdANypA6KZhXCe0moI59dOLrQrDKeisD6DSm9na3HomYUMH0kMGZnAICRQKR5NhGdwvm_zrJVRrCUz98_V-kg2RfVf-59Rfvcq3UIYxwEV14Ng-PJng6iw",
      "e": "AQAB",
      "ext": true,
      "key_ops": [
        "encrypt"
      ]
    }
  }
];
